module.exports = __webpack_public_path__ + "img/login.fae93f39.png";